module.exports = __webpack_public_path__ + "img/mobile.8492a249.svg";